module.exports = __webpack_public_path__ + "img/IMG_9912.ce47ead5.jpg";